const primary = [
  {
    label: 'Home',
    routeName: 'Private/Home',
    icon: 'house-fill'
  },
  {
    label: 'Pachete Sejur',
    routeName: 'Private/Package/Search',
    icon: 'sun'
  },
  {
    label: 'Circuite',
    routeName: 'Private/Tour2/Search',
    icon: 'card-image'
  },
  // {
  //   label: 'Excursii 1 zi',
  //   routeName: 'Private/Other',
  //   icon: 'envelope'
  // },
  {
    label: 'Hoteluri',
    icon: 'building',
    children:
    [
      {
        label: 'Hoteluri',
        routeName: 'Private/Hotel',
        icon: 'building'
      },
      {
        label: 'Vile Extern',
        routeName: 'Private/Villas',
        icon: 'house'
      }
      // {
      //   label: 'Turism Intern - Romania',
      //   routeName: 'Private/Intern',
      //   icon: 'geo'
      // }
    ]
  },
  {
    label: 'Bilete Autocar',
    routeName: 'Private/Bus',
    icon: 'compass'
  },
  {
    label: 'Rezervari',
    routeName: 'Private/Bookings',
    icon: 'card-checklist'
  },
  {
    label: 'Contact',
    routeName: 'Private/Contact',
    icon: 'envelope'
  }
]

const secondary = [
  {
    label: 'cont',
    routeName: 'Private/Account',
    icon: 'person'
  },
  {
    label: 'log out',
    routeName: 'Private/Logout',
    icon: 'power'
  }
]

export {
  primary,
  secondary
}
